import React from 'react';
import { Dialog, DialogTitle, DialogContent, Button, Box } from '@mui/material';
import { PDFViewer, pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import ContractPDFSimple from './ContractPDFSimple';
import { Download as DownloadIcon } from '@mui/icons-material';

const PDFModalContract = ({ open, onClose, contract }) => {
  const handleDownloadPDF = async () => {
    if (!contract) return;

    try {
      const blob = await pdf(<ContractPDFSimple contract={contract} />).toBlob();
      saveAs(blob, `contrat-${contract.reference || 'sans-reference'}.pdf`);
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <span>Voir PDF - Contrat de Travail</span>
          <Button 
            variant="contained" 
            startIcon={<DownloadIcon />}
            onClick={handleDownloadPDF}
            color="primary"
          >
            Télécharger
          </Button>
        </Box>
      </DialogTitle>
      <DialogContent>
        {contract ? (
          <PDFViewer style={{ width: '100%', height: '600px' }}>
            <ContractPDFSimple contract={contract} />
          </PDFViewer>
        ) : (
          <Box p={2} textAlign="center">
            Aucune donnée de contrat disponible
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PDFModalContract;
